const { client, loadToken } = require('./client');

export { loadToken };

// --- Translation API Calls ---

export async function getTranslations() {
    var { data } = await client.get('/translations');
    return data;
}

export async function getTranslationTypes() {
    var { data } = await client.get('/translations/types');
    return data;
}

export async function getTranslation(id) {
    var { data } = await client.get(`/translations/${id}`);
    return data;
}

export async function createTranslation(translationData) {
    var { data } = await client.post('/translations', translationData);
    return data;
}

export async function updateTranslation(id, translationData) {
    var { data } = await client.put(`/translations/${id}`, translationData);
    return data;
}

export async function deleteTranslation(id) {
    var { data } = await client.delete(`/translations/${id}`);
    return data;
}

// Add it to your exports:
const all = {
    loadToken,
    getTranslations,
    getTranslationTypes,
    getTranslation,
    createTranslation,
    updateTranslation,
    deleteTranslation
};

export default all;